// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"723":"4d00b6d761cfb2db","739":"d9b83fd1e40b1f4c","952":"389acd2b0c839b2d"}[chunkId] + ".js";
};